import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import UDButton from 'ud-ui/components/button';
import Modal from 'ud-ui/components/modal';
import UDText from 'ud-ui/components/text';
import useSaveScheme from '../../use-save-scheme';

interface IProps {
  onSuccess: () => void;
}

function useNotionModal(props: IProps) {
  const { onSuccess } = props;
  const [isSaving, setIsSaving] = useState(false);
  const { saveScheme } = useSaveScheme();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const save = useCallback(() => {
    setIsSaving(true);
    saveScheme()
      .then(() => {
        toast.success('Табло успешно сохранено');
        onSuccess();
      })
      .catch((error) => {
        console.error(error);
        toast.error('Не удалось сохранить');
      });
  }, [saveScheme, onSuccess]);

  return {
    modal: (
      <Modal show={isOpen} onClose={close}>
        <Modal.Header title="Сохранить изменения?" />
        <Modal.Body>
          <UDText variant="text-2">У вас есть несохранённые изменения</UDText>
        </Modal.Body>
        <Modal.Footer className="w-[400px]">
          <UDButton variant="secondary" type="button" onClick={onSuccess} loading={isSaving}>
            Покинуть страницу
          </UDButton>
          <UDButton variant="primary" type="button" onClick={save} loading={isSaving}>
            Сохранить
          </UDButton>
        </Modal.Footer>
      </Modal>
    ),
    open,
    close,
  };
}

export default useNotionModal;
